export const getFilters = async (store) => {
  const requests = {
    advertiser_id: store.requestGet('Advertisers/getList'),
    offer_id: store.requestGet('Offers/getOffersList'),
    landing_id: store.requestGet('Offers/getLandingsList'),
    app_id: store.requestGet('PWA/getAppsList'),
    bayer_id: store.requestGet(`Traffics/Facebook/getBayersList`),
    traffic_id: store.requestGet('Traffics/Facebook/getCompaniesList'),
    pixel_id: store.requestGet('Pixels/getPixels'),
    link_id: store.requestGet('Traffics/Facebook/getLinksList'),
    app_service_id: store.requestGet('Apps/getServicesList'),
    brand_id: store.requestGet('Brands/getBrands'),
    country_id: store.requestGet('Countries/getList'),
    bot_id: store.requestGet('Bots/getListBots'),
    channel_id: store.requestGet('Channels/getChannelsList'),
    tg_account_id: store.requestGet(`TgAccounts/getTgAccounts`),
    channel_group_id: store.requestGet('Content/getGroups'),
  };

  const results = await Promise.all(Object.values(requests));
  const keys = Object.keys(requests);
  const data = Object.fromEntries(keys.map((key, index) => [key, results[index]]));

  const filtersObj = {
    ...data,
    app_type: [
      {name: 'PWA', id: 'pwa'},
      {name: 'IOS', id: 'ios'},
      {name: 'Android', id: 'android'},
    ],
    state: [
      {name: 'С Данными', id: 'with_data'},
      {name: 'С Кликами', id: 'clicks'},
      {name: 'Без Кликов', id: 'without_clicks'},
      {name: 'С Лидами', id: 'leads'},
      {name: 'Без Лидов', id: 'without_leads'},
      {name: 'С Регистрациями', id: 'reg'},
      {name: 'Без Регистраций', id: 'without_reg'},
      {name: 'С Квалификациями', id: 'cpa'},
      {name: 'Без Квалификаций', id: 'without_cpa'},
      {name: 'Активно', id: 'active'},
      {name: 'Не активно', id: 'inactive'},
      {name: 'Недавно Создано', id: 'recently_created'},
    ],
    traffic_type: [
      {name: 'Приложения ', id: 'pwa'},
      {name: 'Схемы', id: 'telegram'},
    ],
    country_id: data.country_id.map(({name, id, flag}) => ({name, id, flag})),
    tg_account_id: data.tg_account_id.map((item) => ({...item, name: item?.username})),
  };

  const excludedKeys = ['app_type', 'state', 'traffic_type', 'country_id'];

  Object.entries(filtersObj).forEach(([key, value]) => {
    if (
      !excludedKeys.includes(key) &&
      Array.isArray(value) &&
      value.every((v) => v?.id !== undefined)
    ) {
      value.sort((a, b) => {
        const aId = isNaN(a.id) ? a.id : Number(a.id);
        const bId = isNaN(b.id) ? b.id : Number(b.id);
        return bId > aId ? 1 : bId < aId ? -1 : 0;
      });
    }
  });

  return filtersObj;
};
